export const STEPS_FOUR_STAGES = ['build', 'ultralabs', 'accessoriesnew', 'review'];

export const STEPS_TITLE_FOUR_STAGES = {
  build: 'Build',
  ultralabs: 'Ultralabs ',
  accessoriesnew: 'Accessories',
  review: 'Review',
};

export const STEPS_PAGE_TITLES_FOUR_STAGES = {
  build: 'CREATE YOUR DREAM RIG',
  ultralabs: 'PERSONALISE YOUR DREAM RIG',
  accessoriesnew: 'ACCESSORISE YOUR DREAM RIG',
  review: 'CONFIRM YOUR DREAM RIG',
};